import { portfolioCases, portfolioVisions } from '../data/portfolioCases';

export const createSlug = (company: string, title: string): string => {
  const combined = `${company} ${title}`;
  return combined
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')  // Remove special characters
    .replace(/\s+/g, '-')          // Replace spaces with hyphens
    .replace(/-+/g, '-')           // Replace multiple hyphens with single
    .trim()                        // Remove leading/trailing whitespace
    .replace(/^-+|-+$/g, '');      // Remove leading/trailing hyphens
};

export const findCaseBySlug = (slug: string) => {
  return portfolioCases.find(case_ => case_.slug === slug) || portfolioVisions.find(case_ => case_.slug === slug) || null;
};